(function () {
  'use strict';

  angular.module('lead.status').directive('leadStatus', leadStatus);

  leadStatus.$inject = [];

  function leadStatus() {
    var directive = {
      bindToController: true,
      controller: 'LeadStatusCtrl',
      controllerAs: 'vm',
      template: require('../lead.status/lead.status.html'),
      link: link,
      restrict: 'AE',
      scope: {
        statusId: '=statusId',
        leadId: '=leadId',
      },
    };
    return directive;

    function link(scope, element, attrs) {
      element.bind({
        keydown: function (e) {
          // up and down keys are blocked, because on MacOS native contol appeared
          if (
            e.which == 38 ||
            e.keyCode == 38 ||
            e.which == 40 ||
            e.keyCode == 40
          ) {
            return false;
          }
          return true;
        },
      });
    }
  }
})();
